import axios from 'CanExConfig/axios'

const endpoint = '/users'

export const userSignOut = async () => {
  const response = await axios(`${endpoint}/sign_out`, {
    method: 'DELETE',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  })

  return response.data
}
